import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../Component/Button/Button'
import Style from './Page404.module.css'

const Page404 = () => {
    const history=useHistory()
    return (
        <div className={Style.pageHolder}>
            <div className={Style.picHolder}>
                <img src={"/Assets/Images/page404/404.png"} alt="صفحه 404"/>
            </div>
            <h2 className={Style.adad}>404</h2>
            <p className={Style.textAlert}>متاسفانه صفحه مورد نظر شما یافت نشد</p>
            <div className={Style.btnHolder}>
                <Button ClassBtn={"confrimBtn"} Value={"صفحه شروع"} ClickHandler={()=>history.push("/")}/>
            </div>
        </div>
    )
}
export default Page404
